import moment from "moment";

export const getAsianGameListData = (gameList, byDateSort) => {
    const asianGameListData = Object.values(gameList).filter(item => item.start_ts);

    if (byDateSort) {
        let orderedGames = asianGameListData.sort((a, b) => {
            return a.start_ts - b.start_ts;
        });
        const competitionArray = orderedGames.reduce((collected, game, gameIndex, gameArray) => {
            if ((gameIndex > 0) && (`${gameArray[gameIndex - 1].competitionName}${gameArray[gameIndex - 1].regionAlias}` === `${game.competitionName}${game.regionAlias}`)) {
                collected.slice().reverse().find((item) => `${item.key}${item.regionAlias}` === `${game.competitionName}${game.regionAlias}`)[game.competitionName].push(game);
            } else {
                collected.push({
                    [game.competitionName]: [game],
                    key: game.competitionName,
                    regionAlias: game.regionAlias,
                    regionName: game.regionName,
                    teams_reversed: game.competitionTeamsReversed
                });
            }
            return collected;
        }, []);
        return competitionArray.map((competition) => {
            competition[competition.key] = competition[competition.key].map(game => game.id);
            return competition;
        });
    }
    let orderedRegions = asianGameListData.sort((a, b) => {
            return a.regionOrder - b.regionOrder;
        }),
        processed = {};
    const Regions = orderedRegions.reduce((collected, current) => {
        if (!processed.hasOwnProperty(current.regionAlias)) {
            processed[current.regionAlias] = null;
            collected.push({
                [current.regionAlias]: [current],
                regionKey: current.regionAlias
            });
        } else {
            collected.every((region) => {
                region.regionKey === current.regionAlias && region[region.regionKey].push(current);
                return region.regionKey !== current.regionAlias;
            });
        }
        return collected;
    }, []);
    const competitionArray = Regions.map((groupedRegion) => {
        let processed = {};
        return groupedRegion[groupedRegion.regionKey].sort((a, b) => {
            return a.competitionOrder - b.competitionOrder;
        }).reduce((collected, game) => {
            if (!processed.hasOwnProperty(game.competitionName)) {
                processed[game.competitionName] = null;
                collected.push({
                    [game.competitionName]: [game],
                    key: game.competitionName,
                    regionAlias: game.regionAlias,
                    regionName: game.regionName,
                    name: game.sport && game.sport.name,
                    teams_reversed: game.competitionTeamsReversed
                });
            } else {
                collected.every((groupedCompetition) => {
                    groupedCompetition.key === game.competitionName && groupedCompetition[groupedCompetition.key].push(game);
                    return groupedCompetition.key !== game.competitionName;
                });
            }
            return collected;
        }, []);
    }).reduce((collected, regions) => {
        collected.push(
            ...regions.map((region) => {
                region[region.key] = region[region.key].sort((a, b) => {
                    return a.start_ts - b.start_ts;
                }).map(game => game.id);

                return region;
            })
        );
        return collected;
    }, []);
    return competitionArray;
};

export const getAsianGameListDataForAllSports = (asianGameListData, byDateSort) => {
    let sortedData = Object.values(asianGameListData).sort((a, b) => a.order - b.order);
    const bySportAlias = _.groupBy(Object.values(sortedData), 'alias');
    return Object.keys(bySportAlias).map((key) => {
        return {
            temp: key,
            data: getAsianGameListData(bySportAlias[key], byDateSort)
        };
    }).filter(item => item.data?.length);
};

export const getAsianGameUsa = (asianGameListData, byDateSort) => {
    if (!byDateSort) {
        return getAsianGameListData(asianGameListData);
    }

    const values = Object.values(asianGameListData).sort((a, b) => a.start_ts - b.start_ts).map(item => {
        return ({
            ...item,
            start_ts_date: moment.unix(item.start_ts).startOf('day').toDate()
        });
    });

    const byStartTS = _.groupBy(values, 'start_ts_date');
    return byStartTS;
};
